import React, { Component } from "react";

class DatePicker extends Component {
  constructor(props) {
    super(props);

    const baseDate = props.maxDate
      ? new Date(props.maxDate)
      : new Date();

    this.state = {
      selectedDate: props.value ? new Date(props.value) : null,
      rangeStart: null,
      rangeEnd: null,
      currentMonth: baseDate.getMonth(),
      currentYear: baseDate.getFullYear(),
      selectingRange: false,
      showCalendar: false,
    };

    this.wrapperRef = React.createRef();
}

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ showCalendar: false });
    }
  };

  getDaysInMonth = (month, year) => {
    const date = new Date(year, month, 1);
    const days = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  };

  isDisabled = (date) => {
    const { minDate, maxDate } = this.props;
    if (minDate && date < new Date(minDate)) return true;
    if (maxDate && date > new Date(maxDate)) return true;
    return false;
  };

  handleDateClick = (date) => {
    if (this.isDisabled(date)) return;

    const { range } = this.props;
    const { selectingRange, rangeStart } = this.state;

    if (range) {
      if (!selectingRange) {
        this.setState({
          rangeStart: date,
          rangeEnd: null,
          selectingRange: true,
        });
      } else {
        if (date < rangeStart) {
          this.setState(
            { rangeStart: date, rangeEnd: rangeStart, selectingRange: false },
            () => this.triggerOnChange()
          );
        } else {
          this.setState({ rangeEnd: date, selectingRange: false }, () =>
            this.triggerOnChange()
          );
        }
      }
    } else {
      this.setState({ selectedDate: date, showCalendar: false }, () =>
        this.triggerOnChange()
      );
    }
  };

  triggerOnChange = () => {
    const { selectedDate, rangeStart, rangeEnd } = this.state;
    if (this.props.onChange) {
      if (this.props.range) {
        this.props.onChange({ start: rangeStart, end: rangeEnd });
      } else {
        this.props.onChange(selectedDate);
      }
    }
  };

  changeMonth = (offset, e) => {
    e.preventDefault();
    let { currentMonth, currentYear } = this.state;
    currentMonth += offset;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear += 1;
    } else if (currentMonth < 0) {
      currentMonth = 11;
      currentYear -= 1;
    }
    this.setState({ currentMonth, currentYear });
  };

  handleMonthChange = (e) => {
    this.setState({ currentMonth: parseInt(e.target.value, 10) });
  };

  handleYearChange = (e) => {
    this.setState({ currentYear: parseInt(e.target.value, 10) });
  };

  formatDate = (date) => {
    if (!date) return "";
    return date.toLocaleDateString("en-CA");
  };

  Icon = (() => (
    <span style={{ marginLeft: 5 }}>
      <img src="images/te_Calander_icon.svg" alt="calendar icon" />
    </span>
  ));

  render() {
    const {
      currentMonth,
      currentYear,
      selectedDate,
      rangeStart,
      rangeEnd,
      showCalendar,
    } = this.state;
    const days = this.getDaysInMonth(currentMonth, currentYear);
    const firstDayWeekday = new Date(currentYear, currentMonth, 1).getDay();
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const styles = this.props.styles || {};
    const minYear = this.props.minDate
      ? new Date(this.props.minDate).getFullYear()
      : currentYear - 50;
    const maxYear = this.props.maxDate
      ? new Date(this.props.maxDate).getFullYear()
      : currentYear + 50;
    const years = [];
    for (let y = minYear; y <= maxYear; y++) years.push(y);

    let inputValue = "";
    if (this.props.range) {
      if (rangeStart && rangeEnd)
        inputValue = `${this.formatDate(rangeStart)} - ${this.formatDate(
          rangeEnd
        )}`;
      else if (rangeStart) inputValue = this.formatDate(rangeStart);
    } else {
      inputValue = this.formatDate(selectedDate);
    }

    // Add empty slots for first week alignment
    const calendarCells = [];
    for (let i = 0; i < firstDayWeekday; i++) {
      calendarCells.push(<div key={`empty-${i}`}></div>);
    }
    days.forEach((date) => calendarCells.push(date));

    return (
      <div className={styles.dob_container} ref={this.wrapperRef}>
        {/* Input field */}
        <div
          className={styles.input_wrapper}
          style={{ display: "flex", alignItems: "center" }}
        >
          <input
            type="text"
            readOnly
            value={inputValue}
            onClick={() => this.setState({ showCalendar: !showCalendar })}
            className={styles.input}
            placeholder={this.props.placeholder || "Select date"}
          />
          <div
            onClick={() => this.setState({ showCalendar: !showCalendar })}
            style={{
              position: "absolute",
              right: 10,
              top: -7,
              cursor: "pointer",
            }}
          >
            {this.props.icon || this.Icon()}
          </div>
        </div>

        {/* Calendar popup */}
        {showCalendar && (
          <div className={styles.calendar_popup}>
            {/* Header */}
            <div className={styles.calendar_header}>
              <button onClick={(e) => this.changeMonth(-1, e)}>
                <img
                  src="/images/left_arrow.svg"
                  style={{ width: 15, height: 15 }}
                  alt="left arrow"
                />
              </button>
              <div>
                <select
                  value={currentMonth}
                  onFocus={(e) => (e.target.style.outline = "none")}
                  onChange={this.handleMonthChange}
                  className={styles.year_dropdown}
                >
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i} value={i}>
                      {new Date(0, i).toLocaleString("default", {
                        month: "long",
                      })}
                    </option>
                  ))}
                </select>
                <select
                  value={currentYear}
                  className={styles.year_dropdown}
                  onFocus={(e) => (e.target.style.outline = "none")}
                  onChange={this.handleYearChange}
                >
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <button onClick={(e) => this.changeMonth(1, e)}>
                <img
                  src="/images/right_arrow.svg"
                  style={{ width: 15, height: 15 }}
                  alt="right arrow"
                />
              </button>
            </div>

            {/* Weekdays */}
            <div className={styles.weekdays_container}>
              {weekdays.map((day) => (
                <div key={day}>{day}</div>
              ))}
            </div>

            {/* Days */}
            <div className={styles.days_container}>
              {calendarCells.map((cell, idx) => {
                if (cell instanceof Date) {
                  const date = cell;
                  const isSelected =
                    selectedDate &&
                    date.toDateString() === selectedDate.toDateString();
                  const inRange =
                    rangeStart &&
                    rangeEnd &&
                    date >= rangeStart &&
                    date <= rangeEnd;
                  const disabled = this.isDisabled(date);

                  let dayStyle = {
                    padding: "6px",
                    textAlign: "center",
                    cursor: "pointer",
                    ...styles.day,
                  };
                  if (isSelected)
                    dayStyle = { ...dayStyle, ...styles.selectedDay };
                  else if (inRange)
                    dayStyle = { ...dayStyle, ...styles.inRangeDay };
                  if (disabled)
                    dayStyle = {
                      ...dayStyle,
                      opacity: 0.3,
                      color: "#9CA3AF",
                   
                      cursor: "not-allowed",
                      pointerEvents: "none",
                      ...styles.disabledDay,
                    };

                  return (
                    <div
                      key={date}
                      style={dayStyle}
                      onClick={() => this.handleDateClick(date)}
                    >
                      {date.getDate()}
                    </div>
                  );
                } else {
                  // empty slot
                  return <div key={`empty-${idx}`}></div>;
                }
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default DatePicker;
